import React from 'react';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';
import MainPage from '../../../composents/MainPage';

const title = 'Hydropdrip entities';
const headers = {
	icon: 'feather icon-command',
	title: title,
	description: 'track and manage entities information',
};

export default function HyrdrodripPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'Country name',
						field: 'country',
						renderStyle: (el) => el?.city?.country?.name,
					},
					{
						label: 'City name',
						field: 'city',
						render: ['name'],
					},
					{
						label: 'Entity name',
						field: 'name',
					},
					{
						label: 'Description',
						field: 'description',
					},
				]}
				resource={resources.entity}
				title={title}
				link="/hydrodrip/hd_entities"
			/>
		</MainPage>
	);
}
